import { getLocalStorage } from '@common/utils/localStorage/getLocalStorage'
import { removeLocalStorage } from '@common/utils/localStorage/removeLocalStorage'
import { setLocalStorage } from '@common/utils/localStorage/setLocalStorage'

export interface CinemaUrl {
    title: string
    url: string
    pageAlias: string
}

export interface RecentCinemaStorage {
    cinemas: CinemaUrl[]
    timestamp: number
}

const storageKey = 'recentCinemas'

export const addRecentCinemas = (cinema: CinemaUrl) => {
    const recentCinemaStorage = getLocalStorage<RecentCinemaStorage>(storageKey)

    if (!recentCinemaStorage) {
        setLocalStorage(storageKey, { timestamp: new Date().getTime(), cinemas: [cinema] })
        return
    }

    const cinemaExists = recentCinemaStorage?.cinemas?.find(x => x.url === cinema.url)
    if (cinemaExists) {
        setLocalStorage(storageKey, {
            timestamp: new Date().getTime(),
            cinemas: [...recentCinemaStorage.cinemas],
        })

        return
    }

    if (recentCinemaStorage.cinemas.length === 3) {
        recentCinemaStorage.cinemas.pop()
    }

    setLocalStorage(storageKey, {
        timestamp: new Date().getTime(),
        cinemas: [cinema, ...recentCinemaStorage.cinemas],
    })
}

export const getRecentCinemas = (): CinemaUrl[] => {
    const recentCinemaStorage = getLocalStorage<RecentCinemaStorage>(storageKey)

    if (!recentCinemaStorage) {
        return []
    }

    const currentTime = Date.now()
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000

    if (currentTime - recentCinemaStorage.timestamp >= oneDayInMilliseconds) {
        removeLocalStorage(storageKey)
        return []
    } else {
        return recentCinemaStorage.cinemas
    }
}